package one.healthium.login.navigation.silent_login

import androidx.lifecycle.ViewModelStoreOwner
import com.arkivanov.decompose.ComponentContext
import one.healthium.decompose.viewModelStoreOwner
import one.healthium.domain.user.UserModel

class DefaultSilentLoginComponent(
    componentContext: ComponentContext,
    override val token: String,
    private val onUserSignedIn: (UserModel) -> Unit,
    private val onDeclined: () -> Unit,
) : SilentLoginComponent, ComponentContext by componentContext, ViewModelStoreOwner by componentContext.viewModelStoreOwner() {
    override fun onUserSignedIn(user: UserModel) {
        onUserSignedIn.invoke(user)
    }

    override fun onDeclined() {
        onDeclined.invoke()
    }
}